import { useEffect, useState } from 'react';
import { s } from './Pattern.styles';
import Select from 'react-select';
import RegionService from '../../../../service/Region';
import {
  ItemStatusList,
  RegionProps,
  SidoList,
  UseAreaLIst,
} from '../../../search/FilterData';

import { UseArea2 } from '../../../search/filter/UseArea';
import { usePatternContext } from '../../../../context/PatternContext';
import { Pattern1 } from './data';
import OptionTooltip from './OptionTooltip';
import styled from 'styled-components';

const AnalysisCriteria = () => {
  const [sigunguList, setSigunguList] = useState<RegionProps[] | undefined>([]);
  const [emdList, setEmdList] = useState<RegionProps[] | undefined>([]);
  const [showUsageArea, setShowUsageArea] = useState<boolean>(false);
  const {
    setIsStep1Done,
    patternInfo,
    setIsCheckAvaiable,
    setSelectedTab,
    sido,
    sigungu,
    setSido,
    setSigungu,
    setEmd,
    pattern1,
    setPattern1,
    isEditMode,
    emd,
    setIsLastTipOn,
  } = usePatternContext();
  const [tooltips, setTooltips] = useState<{ [key: string]: boolean }>({
    tooltip1: false,
    tooltip2: false,
    tooltip3: false,
  });

  const handleTooltipToggle = (tooltipKey: string) => {
    setTooltips((prev) => ({
      ...prev,
      [tooltipKey]: !prev[tooltipKey],
    }));
  };

  useEffect(() => {
    setIsLastTipOn(tooltips.tooltip3);
  }, [tooltips.tooltip3]);

  const customStyles = {
    container: (provided: any) => ({
      ...provided,
      flex: 1,
    }),
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      background: '#F7F8FC',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '-2%',
      lineHeight: '145%',
      color: '#616161',
      width: '100%',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '14px',
      fontWeight: 500,
      letterSpacing: '-2%',
      lineHeight: '145%',
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#222222' : '#616161',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      paddingRight: 0, // 패딩을 없앰
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };
  const getRegion = async (code: string) => {
    try {
      const res = await RegionService.list(code);
      return res.data as RegionProps[];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isEditMode) {
      const currentSido = SidoList.find(
        (sido) => sido.region === patternInfo.ctp,
      )?.code;
      setSido(currentSido ?? '');
      getRegion(currentSido ?? '').then((res) => {
        setSigunguList(res);
        const currentSigungu =
          res &&
          res.find((sigungu) => sigungu.region === patternInfo.sig)?.code;
        setSigungu(currentSigungu ?? '');
      });
      getRegion(sigungu).then((res) => {
        setEmdList(res);
        const currentEmd =
          res && res.find((emd) => emd.region === patternInfo.emd)?.code;
        setEmd(currentEmd ?? '');
      });
    }
  }, [isEditMode]);

  useEffect(() => {
    if (sido !== '') {
      getRegion(sido).then((res) => setSigunguList(res));
    }
  }, [sido]);

  useEffect(() => {
    if (sigungu !== '') {
      getRegion(sigungu).then((res) => setEmdList(res));
    }
  }, [sigungu]);

  const sidoOptions = SidoList.map((sido) => ({
    value: sido.code,
    label: sido.region,
  }));
  const sigunguOptions = (sigunguList ?? []).map((sigungu) => ({
    value: sigungu.code,
    label: sigungu.region,
  }));
  const emdOptions = (emdList ?? [])
    .filter((emd) => emd.region !== '전체')
    .map((emd) => ({
      value: emd.code,
      label: emd.region,
    }));
  const handleFocus = (event: any) => {
    event.target.showPicker();
  };

  const handleReset = () => {
    setSido('');
    setSigungu('');
    setEmd('');
    setSigunguList([]);
    setEmdList([]);
    setPattern1({
      type: 'A',
      region: { sido: '', sigungu: '', emd: '' },
      itemStatus: '',
      useArea: [],
      multiUseArea: [],
      analysisPeriod: { start: '2022-01-01', end: '2024-12-31' },
      pnu: '',
    });
  };

  useEffect(() => {
    if (
      pattern1.region.sido &&
      pattern1.itemStatus &&
      pattern1.analysisPeriod.start &&
      pattern1.analysisPeriod.end
    ) {
      setIsCheckAvaiable(true);
      // setIsStep1Done(true);
    } else {
      setIsCheckAvaiable(false);
      // setIsStep1Done(false);
    }
  }, [pattern1]);

  return (
    <s.PatterBoxInner>
      <s.Column>
        <s.Block>
          <s.BlockLabel>
            <span style={{ fontSize: '16px', fontWeight: '700' }}>분석기준</span>
          </s.BlockLabel>
          <ContentBox>
            알고리즘을 만들기 위해 <span> 분석 기준을 선택 </span> 해주세요
          </ContentBox>
        </s.Block>
      </s.Column>
      <s.Column>
        <s.Block>
          <s.BlockLabel>
            <span>분석유형</span>
            <img
              src="/assets/images/icon/info-16.svg"
              alt=""
              onClick={() => {
                handleTooltipToggle('tooltip1');
              }}
              style={{ cursor: 'pointer' }}
            />
          </s.BlockLabel>
          {tooltips.tooltip1 && (
            <OptionTooltip
              text={[
                '(경매 낙찰+매각)\n 경매 낙찰 후, 매각까지 완료한 유형',
                `(경매 낙찰+임대)\n 경매 낙찰 후, 임대(전월세) 완료한 유형`,
              ]}
              setTooltip={() => handleTooltipToggle('tooltip1')}
            />
          )}
          <s.AnalysisTabBox>
            <s.AnalysisTab
              // onChange={(e) => {
              //   setPattern1({ ...pattern1, type: e.target.value });
              // }}
              onClick={() => setPattern1({ ...pattern1, type: 'A' })}
              isActive={pattern1.type === 'A'}
            >
              경매 낙찰+매각
            </s.AnalysisTab>
            <s.AnalysisTab
              onClick={() => setPattern1({ ...pattern1, type: 'B' })}
              isActive={pattern1.type === 'B'}
            >
              <div>경매 낙찰+임대</div>
              {/* <s.TempBox>제공예정</s.TempBox> */}
            </s.AnalysisTab>
          </s.AnalysisTabBox>
        </s.Block>
        <s.Block>
          <s.BlockLabel>
            <span> 분석지역</span>
          </s.BlockLabel>
          <s.BlockContent>
            <div style={{ width: '100%' }}>
              <Select
                options={sidoOptions}
                value={
                  sidoOptions.find(
                    (option) => option.label === pattern1.region.sido,
                  ) || null
                }
                styles={customStyles}
                menuPortalTarget={document.body}
                placeholder="시/도"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSido(selectedOption.value);
                    setSigungu('');
                    setEmd('');
                    setPattern1({
                      ...pattern1,
                      region: {
                        sido: selectedOption.label,
                        sigungu: '',
                        emd: '',
                      },
                      pnu: selectedOption.value,
                    });
                  }
                }}
              />
            </div>
            <div style={{ width: '100%' }}>
              <Select
                options={sigunguOptions}
                value={
                  sigunguOptions.find(
                    (option) => option.label === pattern1.region.sigungu,
                  ) || null
                }
                menuPortalTarget={document.body}
                styles={customStyles}
                placeholder="구/군"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSigungu(selectedOption.value);
                    setEmd('');
                    setPattern1({
                      ...pattern1,
                      region: {
                        sido: pattern1.region.sido,
                        sigungu: selectedOption.label,
                        emd: '',
                      },
                      pnu: selectedOption.value,
                    });
                  }
                }}
                noOptionsMessage={() => '시/도 먼저'}
              />
            </div>
            <div style={{ width: '100%' }}>
              <Select
                options={emdOptions}
                value={
                  emdOptions.find(
                    (option) => option.label === pattern1.region.emd,
                  ) || null
                }
                menuPortalTarget={document.body}
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="읍/면/동"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setEmd(selectedOption.value);
                    setPattern1({
                      ...pattern1,
                      region: {
                        sido: pattern1.region.sido,
                        sigungu: pattern1.region.sigungu,
                        emd: selectedOption.label,
                      },
                      pnu: selectedOption.value,
                    });
                  }
                }}
                noOptionsMessage={() => '구/군 먼저'}
              />
            </div>
          </s.BlockContent>
        </s.Block>
      </s.Column>
      <s.Column>
        <s.Block>
          <s.BlockLabel>
            <span>물건종류</span>
            <img
              src="/assets/images/icon/info-16.svg"
              alt=""
              onClick={() => {
                handleTooltipToggle('tooltip2');
              }}
              style={{ cursor: 'pointer' }}
            />
          </s.BlockLabel>
          {tooltips.tooltip2 && (
            <OptionTooltip
              text={[`분석하고 싶은 부동산 유형을 선택하세요.`]}
              setTooltip={() => handleTooltipToggle('tooltip2')}
            />
          )}
          <s.BlockContent>
            <div style={{ flex: 1 }}>
              <Select
                options={ItemStatusList.slice(1)}
                menuPortalTarget={document.body}
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="선택"
                value={
                  pattern1.itemStatus === ''
                    ? null
                    : {
                        label: pattern1.itemStatus,
                        value: pattern1.itemStatus,
                      }
                }
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setPattern1({
                      ...pattern1,
                      itemStatus: selectedOption.value,
                    });
                  }
                }}
              />
            </div>
          </s.BlockContent>
        </s.Block>
        <s.Block>
          <s.BlockLabel>분석기간</s.BlockLabel>
          <s.BlockContent>
            <s.DateInput
              type="date"
              onFocus={handleFocus}
              placeholder=""
              value={pattern1.analysisPeriod.start}
              onChange={(e) => {
                setPattern1({
                  ...pattern1,
                  analysisPeriod: {
                    ...pattern1.analysisPeriod,
                    start: e.target.value,
                  },
                });
              }}
            />
            <span>~</span>
            <s.DateInput
              type="date"
              onFocus={handleFocus}
              placeholder=""
              value={pattern1.analysisPeriod.end}
              onChange={(e) => {
                setPattern1({
                  ...pattern1,
                  analysisPeriod: {
                    ...pattern1.analysisPeriod,
                    end: e.target.value,
                  },
                });
              }}
            />
          </s.BlockContent>
        </s.Block>
      </s.Column>
      <s.Column>
        <s.Block style={{ flex: 0.5 }}>
          <s.BlockLabel>
            <span> 용도지역</span>
            <img
              src="/assets/images/icon/info-16.svg"
              alt=""
              onClick={() => {
                handleTooltipToggle('tooltip3');
              }}
              style={{ cursor: 'pointer' }}
            />
          </s.BlockLabel>
          {tooltips.tooltip3 && (
            <OptionTooltip
              text={[
                `분석하고 싶은 용도지역을 선택하세요.\n 기본은 전체선택입니다.`,
              ]}
              setTooltip={() => handleTooltipToggle('tooltip3')}
            />
          )}
          <s.FilterRowContent>
            <div style={{ flex: 1 }}>
              <Select
                options={UseAreaLIst}
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="선택"
                value={
                  pattern1.useArea.length > 0
                    ? {
                        label: pattern1.useArea[0],
                        value: pattern1.useArea[0],
                      }
                    : null
                }
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setPattern1({
                      ...pattern1,
                      multiUseArea: [],
                      useArea: [selectedOption.label],
                    });
                  }
                }}
                isDisabled={showUsageArea}
              />
            </div>
            {showUsageArea ? (
              <s.PlusButton
                style={{ backgroundColor: '#67708A', color: '#fff' }}
                onClick={() => setShowUsageArea(false)}
              >
                <span>단일선택</span>
                <img src="/assets/images/close/close-white.svg" alt="" />
              </s.PlusButton>
            ) : (
              <s.PlusButton onClick={() => setShowUsageArea(true)}>
                <span>복수선택</span>
                <img src="/assets/images/icon/plus-008aff.svg" alt="" />
              </s.PlusButton>
            )}
          </s.FilterRowContent>
          {showUsageArea && (
            <UseArea2 filters={pattern1} setFilters={setPattern1} />
          )}
        </s.Block>
      </s.Column>
    </s.PatterBoxInner>
  );
};

export default AnalysisCriteria;

const ContentBox = styled.div`
  width: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #eaf2fe;
  color: #222222;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  // word-wrap: break-word;
  span {
    color: #008aff;
  }
`;
